import React from 'react';
import ComponentErp from './ComponentErp.js';
import store from '../store';

import { getSisStatus } from '../services/Auth.js';
import FormEdit from '../components/FormEdit.js';
import { GetFornecedoresAPI } from '../models/ModelFornecedores.js';
import FornecedoresUpdate from './FornecedoresUpdate.js';
import FornecedoresEndereco from './FornecedoresEndereco.js';


class Fornecedores extends ComponentErp {
  constructor(props) {
    super(props);
    this.state = store.getState().fornecedores.grids;
  }

  componentDidMount() {
    this.callApi()
  }

  componentDidUpdate(prevProps, prevState) {

    if (this.state.refresh === 'gravando') {
      this.setState({ refresh: 'buscando' });
      this.callApi()
    }

    if (this.state.refresh === 'limpando') {
      this.actionClick('.cadastro');
    }

    if (this.state.refresh === 'endereco' || this.state.refresh === 'listaendereco') {
      this.actionClick('.endereco');
    }

  }


  handleSubmit = (event) => {
    event.preventDefault()

    var response = {
      refresh: 'gravando',
      fNome: this.state.fNome,
      fStatus: this.state.fStatus,
      type: 'FORNECEDORES.TOOGLE_FBUSCA'
    }
    this.updateReduxAndState(response);
  }

  clickChild = (event, id) => {
    this.clickChildModal(
      id,
      'concluido',
      store.getState().fornecedores.grids.edit.onClick,
      store.getState().fornecedores.grids.edit.itens);

  }

  clickChildCadastro = (event) => {

    event.preventDefault()
    var response = '';
    if (this.state.aba !== 'Cadastro' && this.state.id !== 0 && this.state.id !== store.getState().fornecedores.cadastro.sIdFornecedor) {

      response = {
        id: this.state.id,
        type: 'FORNECEDORES.TOOGLE_CADASTRO'
      }
      this.updateRedux(response);

      //this.actionClick('.cadastro');
      //this.clearModal();
      
    } else if (this.state.id === 0) {
      response = { type: 'FORNECEDORES.TOOGLE_CLEAN', refresh: 'limpando' }
      this.updateRedux(response);

    }
    if (this.state.aba !== 'Cadastro') {
      this.actionClick('.cadastro');
      this.setState({
        refresh: 'buscafornecedorendereco'
      });
      this.clearModal();
    }
    this.setAba('Cadastro');

  }

  clickChildEndereco = (event) => {

    if (this.state.aba !== 'Endereco' && this.state.id !== 0 && this.state.id !== store.getState().fornecedores.enderecos.id_fornecedor) {

      var response = {
        endereco: <FornecedoresEndereco />,
        refresh: 'listaendereco',
        id_fornecedor: this.state.id,
        type: 'FORNECEDORES.ENDERECO.TOOGLE_ID_FORNECEDOR'
      }
      
      this.updateReduxAndState(response);

    }

    if (this.state.aba !== 'Endereco') {
      this.actionClick('.endereco');
      this.clearModal();
    }

    this.setAba('Endereco');
  }

  async callApi() {

    var grids = store.getState().fornecedores.grids;

    var response = await GetFornecedoresAPI(grids.limit, grids.offset, grids.fNome, grids.fStatus);
    response.refresh = 'concluido';
    response.onClickModal = this.clickChild;
    response.callBackPaginacao = this.callBackPaginacao;
    response.editOnClick = [this.clickChildCadastro, this.clickChildEndereco];

    let nav = store.getState().fornecedores.grids.nav;
    nav.disabled[2] = 'disabled';
    nav.onClick[0] = this.clickChildListaAba;
    nav.onClick[1] = this.clickChildCadastro;
    nav.onClick[2] = this.clickChildEndereco;
    response.nav = nav;

    response.type = 'FORNECEDORES.TOOGLE_LISTA';

    this.updateRedux(response);
    grids = store.getState().fornecedores.grids;
    this.setState(grids);
  }



  render() {

    return (

      <div className="container">
        <div className="row">
          <h2 className="section-title">Fornecedores</h2>
          <div className="card">
            {this.navMenu(store.getState().fornecedores.grids.nav)}
            <div id="lista" className="dataTables_wrapper no-footer row">
              <form name="form" onSubmit={this.handleSubmit} action="" method="get" encType="multipart/form-data">

                {<FormEdit id='fNome'
                  onChange={this.handleInputChange}
                  label='Busque por nome'
                  value={this.state.fNome}
                  styleDiv='4' />}

                {<FormEdit id='fStatus'
                  label='Status'
                  styleDiv='4'
                  onChange={this.handleInputChange}
                  typeField='select'
                  value={this.state.fStatus}
                  optionsField={getSisStatus('status_padrao')} />}

                {<FormEdit id='submit'
                  label='Pesquisar'
                  styleDiv='submit'
                  styleField='submit'
                  typeField='submit'
                  icon='pesquisa'
                />}

                {<FormEdit id='cadNovo'
                  label='Novo Cadastro'
                  styleDiv='submit'
                  onClick={this.novoCadastro}
                  styleField='submit'
                  typeField='button'
                  icon='adiciona'
                />}

              </form>

              {this.Grid(store.getState().fornecedores.grids)}

            </div>
            <div id="cadastro" className="dataTables_wrapper no-footer row">
              {<FornecedoresUpdate />}
            </div>
            <div id="endereco" className="dataTables_wrapper no-footer row">
              {store.getState().fornecedores.grids.endereco}
            </div>
          </div>
        </div>
      </div>

    );

  }
}
export default (Fornecedores); 
